import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { popupReducer as popup } from 'dbrain-web-ui-lib'
import app from '../components/App/reducers'
// import help from '../components/Help/reducers'
// import user from '../components/User/reducers'
// import withdraw from '../components/Withdraw/reducers'
// import merge from '../components/MergeAccounts/reducers'
import tasks from '../components/Task/reducers'
// import error from '../components/Error/reducers'

const reducers = combineReducers({
	app,
	// help,
	// user,
	// withdraw,
	// error,
	// merge,
	popup,
	tasks,
	router: routerReducer,
})

export default reducers
